import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"

import RunSummary from "./components/RunSummary"
import RunBillsTable from "./components/RunBillsTable"
import { clearRunReview, fetchPreflight, fetchRunBills } from "./clientBatchingSlice"

export default function RunReviewPage() {
    const dispatch = useDispatch()
    const { runId } = useParams()

    useEffect(() => {
        dispatch(clearRunReview({ keepPreflightFilter: true, runId }))
        dispatch(fetchRunBills(runId))
        // The banner's "Finding 2 of 5" needs the findings list. Normally it is still in state from
        // the Pre-Flight page; fetch it only if a finding filter arrived without it.
        dispatch((innerDispatch, getState) => {
            const { preflightFilter, preflight } = getState().clientBatching
            if (preflightFilter && !preflight) innerDispatch(fetchPreflight(runId))
        })
        return () => dispatch(clearRunReview())
    }, [dispatch, runId])

    return (
        <div>
            <RunSummary />
            <div style={{ marginTop: "20px" }}>
                <RunBillsTable />
            </div>
        </div>
    )
}
